// PARAQTA — Жан дос беті (Stage 6.9.1 founder mock redesign).
// Brand rule: "Жан дос" / "Жан досы" / "Жан достары" — WITHOUT hyphen.
// Plans data API-дан, features hard-coded (founder mock).

import { api } from '../../core/api.js';
import { show } from '../../core/router.js';
import { toast } from '../../utils/toast.js';
import { esc } from '../../utils/format.js';

const root = () => document.getElementById('pg-jandos');
const state = { data: null, loading: false };

const FEATURES = [
  { icon: 'ti-target-arrow', title: 'Жылдық оқу мақсаты',  desc: 'Мақсат қой, прогресіңді бақыла' },
  { icon: 'ti-chart-line',   title: 'Толық статистика',     desc: 'Ай · Жыл · Бар уақыт кесінділері' },
  { icon: 'ti-sparkles',     title: 'Айлық + жылдық есеп',  desc: 'Stories форматында бөліс', featured: true },
  { icon: 'ti-books',        title: 'Кітап ұсыныстары',     desc: 'Талғамыңа сай — жанр + ұқсас оқырмандар' },
  { icon: 'ti-trophy',       title: 'Достар рейтингі',      desc: 'Достарыңмен бәсекелес' },
  { icon: 'ti-users-group',  title: 'Клуб ашу',             desc: 'Өз клубыңды аш — қосылу бәріне тегін' },
  { icon: 'ti-link',         title: 'Custom URL',           desc: 'paraqta.kz/атың' },
  { icon: 'ti-feather',      title: 'Жан дос белгісі',      desc: 'Профиліңде алтын белгі' },
];

function planById(plans, price) {
  return plans.find(p => Number(p.price_kzt) === price) || null;
}

function planCardHtml(p, isActive, opts = {}) {
  const goldClass = opts.gold ? ' jandos-plan-gold' : '';
  const activeClass = isActive ? ' jandos-plan-active' : '';
  const badge = opts.badge
    ? `<div class="jandos-plan-badge">${esc(opts.badge)}</div>`
    : '';
  const activeTag = isActive
    ? `<div class="jandos-plan-active-tag">ҚОЛДАНУДА</div>`
    : '';
  return `
    <div class="jandos-plan${goldClass}${activeClass}" data-plan-id="${esc(String(p.id))}">
      ${badge}
      <div class="jandos-plan-eyebrow">${esc(opts.eyebrow)}</div>
      <div class="jandos-plan-price">${esc(p.price_label)}</div>
      <div class="jandos-plan-unit">айына</div>
      <div class="jandos-plan-desc">${opts.desc}</div>
      ${activeTag}
    </div>
  `;
}

function tierCardHtml(t) {
  const active = t.months === _selMonths;
  const badge = t.badge ? `<div class="jandos-tier-badge">${esc(t.badge)}</div>` : '';
  const per = (t.per && t.months > 1)
    ? `<div class="jandos-tier-per">${t.per}₸/ай</div>`
    : '<div class="jandos-tier-per">&nbsp;</div>';
  return `
    <button class="jandos-tier${active ? ' active' : ''}" data-tier-page="${t.months}">
      ${badge}
      <div class="jandos-tier-label">${esc(t.label)}</div>
      <div class="jandos-tier-price">${t.amount}<span>₸</span></div>
      ${per}
    </button>
  `;
}

function render() {
  const node = root();
  if (!node) return;
  const d = state.data || { plans: [], user_status: 'free', current_plan_id: null };
  const plans = d.plans || [];
  const status = d.user_status || 'free';
  const currentPlanId = d.current_plan_id;

  const planSolo = planById(plans, 690);
  // Stage 7.5: Family жоспар (1990₸) уақытша алынды — тек Жан дос (690₸) қалды.
  // Болашақта қайта қосуға болады.
  const planFamily = null;

  const isSoloActive   = planSolo   && String(planSolo.id)   === String(currentPlanId);
  const isFamilyActive = false;
  const anyActive = isSoloActive || isFamilyActive;

  const defaultCheckoutId = planSolo ? planSolo.id : '';

  const ctaLabel = anyActive ? 'Активті' : 'PARAQTA-ның Жан досы бол';
  const ctaDisabled = anyActive ? 'disabled' : '';

  node.innerHTML = `
    <!-- TOP NAV -->
    <div class="v2-top-nav">
      <button data-action="jandos-back" aria-label="Артқа" class="v2-nav-btn">
        <i class="ti ti-arrow-left"></i>
      </button>
      <div class="v2-nav-title">PARAQTA</div>
      <button data-action="theme-toggle" class="v2-nav-btn">
        <i class="ti ti-moon" style="font-size: 14px; opacity: 0.6;"></i>
      </button>
    </div>

    <!-- HERO -->
    <section class="jandos-hero">
      <i class="ti ti-feather jandos-hero-icon"></i>
      <div class="jandos-eyebrow">PARAQTA-НЫҢ</div>
      <h1 class="jandos-title">Жан досы</h1>
      <p class="jandos-subtitle">Толық тәжірибе. Кофеден арзан.</p>
    </section>

    <!-- FEATURES -->
    <section class="jandos-features">
      ${FEATURES.map(f => `
        <div class="jandos-feature${f.featured ? ' featured' : ''}">
          <div class="jandos-feature-icon">
            <i class="ti ${f.icon}"></i>
          </div>
          <div class="jandos-feature-body">
            <div class="jandos-feature-title">${esc(f.title)}</div>
            <div class="jandos-feature-desc">${esc(f.desc)}</div>
          </div>
        </div>
      `).join('')}
    </section>

    <!-- PRICING TIERS (1/3/5 ай, 1 жыл) -->
    <section class="jandos-tiers-wrap">
      <div class="jandos-tiers-head">Жоспарыңды таңда</div>
      <div class="jandos-tiers">
        ${(state.tiers || DEFAULT_TIERS).map(tierCardHtml).join('')}
      </div>
    </section>

    <!-- CTA -->
    <section class="jandos-cta-wrap">
      <button class="jandos-cta-btn"
              data-action="checkout-jandos"
              ${ctaDisabled}>
        ${esc(ctaLabel)}
      </button>
      ${anyActive ? '' : '<div class="jandos-cta-sub">Тоқтату — кез келген уақытта</div>'}
    </section>

    <!-- TRUST BADGES -->
    <section class="jandos-trust">
      <div class="jandos-trust-item">
        <i class="ti ti-credit-card"></i>
        Kaspi-мен төлеу
      </div>
      <div class="jandos-trust-item">
        <i class="ti ti-shield-check"></i>
        Қауіпсіз
      </div>
      <div class="jandos-trust-item">
        <i class="ti ti-x-circle"></i>
        Кез келген уақытта тоқтату
      </div>
    </section>

    <!-- SECONDARY LINK -->
    <div class="jandos-link">
      <a href="https://t.me/oyordabot" target="_blank" rel="noopener">
        Сұрағың бар ма?
      </a>
    </div>
  `;

  // Тиер таңдау → _selMonths (checkout модальмен ортақ айнымалы)
  node.querySelectorAll('[data-tier-page]').forEach(card => {
    card.addEventListener('click', () => {
      _selMonths = +card.dataset.tierPage;
      node.querySelectorAll('.jandos-tier').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
    });
  });
}

const DEFAULT_TIERS = [
  { months: 1, amount: 690, per: 690, label: '1 ай' },
  { months: 3, amount: 1950, per: 650, label: '3 ай' },
  { months: 5, amount: 2950, per: 590, label: '5 ай', badge: 'тиімді' },
  { months: 12, amount: 5900, per: 492, label: '1 жыл', badge: 'ең тиімді' },
];

export async function loadJandos() {
  if (state.loading) return;
  state.loading = true;
  try {
    const [jd, pi] = await Promise.all([
      api('/api/jandos'),
      api('/api/premium/info').catch(() => null),
    ]);
    state.data = jd;
    state.tiers = (pi && pi.tiers && pi.tiers.length) ? pi.tiers : DEFAULT_TIERS;
    render();
  } catch (e) {
    console.error('loadJandos failed', e);
    const node = root();
    if (node) {
      node.innerHTML = '<div style="padding: 60px 20px; text-align: center; font-size: 13px; opacity: 0.6;">Жүктелмеді. Қайта тырысыңыз.</div>';
    }
  } finally {
    state.loading = false;
  }
}

export async function checkoutJandos(planId) {
  // Stage 9: checkout = Kaspi төлем + чек ағыны (бұрынғы placeholder орнына)
  openCheckoutModal();
}

let _selMonths = 1;

export async function openCheckoutModal() {
  const modal = document.getElementById('jandos-checkout-modal');
  const card = document.getElementById('jandosCheckoutCard');
  if (!modal || !card) return;
  modal.style.display = 'flex';
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
  card.style.position = 'relative';
  card.style.maxHeight = '90vh';
  card.style.overflowY = 'auto';
  card.innerHTML = '<div style="padding:34px 0;text-align:center;font-size:13px;opacity:.55">Жүктелуде…</div>';
  let info = null;
  try { info = await api('/api/premium/info'); } catch (_) {}
  _renderCheckout(card, info);
}

function _closeX() {
  return '<button data-action="close-jandos-modal" aria-label="Жабу" style="position:absolute;top:10px;right:12px;width:30px;height:30px;border-radius:50%;border:none;background:rgba(28,26,22,.06);color:var(--ink);font-size:18px;cursor:pointer;line-height:1;z-index:3">×</button>';
}
function _btnFull(label) {
  return '<button data-action="close-jandos-modal" style="width:100%;padding:12px;background:var(--ac);color:var(--card);border:none;border-radius:999px;font-family:Onest,sans-serif;font-weight:600;font-size:14px;cursor:pointer">' + esc(label) + '</button>';
}
const _CAND = '<div style="width:30px;height:44px;margin:6px auto 2px;position:relative"><div style="position:absolute;top:-14px;left:50%;transform:translateX(-50%);width:52px;height:52px;border-radius:50%;background:radial-gradient(circle,rgba(233,169,73,.5),transparent 65%)"></div><div style="position:absolute;top:0;left:50%;transform:translateX(-50%);width:11px;height:17px;border-radius:50% 50% 50% 50%/62% 62% 40% 40%;background:radial-gradient(circle at 50% 72%,#fff7d4,#ffce63 45%,#ff9b3d 80%)"></div><div style="position:absolute;bottom:0;left:50%;transform:translateX(-50%);width:15px;height:26px;border-radius:4px;background:linear-gradient(180deg,#f3e7c8,#e0cb98)"></div></div>';

function _renderCheckout(card, info) {
  // Лаунчқа дейін (enabled=false) — ескі placeholder; тек admin/флаг төлемді көреді
  if (!info || !info.enabled) {
    card.innerHTML = _closeX() +
      '<i class="ti ti-credit-card" style="font-size:42px;color:var(--ac);display:block;text-align:center;margin:8px 0 14px"></i>' +
      '<h2 style="font-family:Georgia,serif;font-size:20px;font-weight:500;text-align:center;color:var(--ink);margin:0 0 10px">Kaspi-мен төлеу</h2>' +
      '<p style="font-size:13px;line-height:1.6;color:color-mix(in srgb,var(--ink) 70%,transparent);text-align:center;margin:0 0 22px">Жақын арада. Күте тұр 🕯</p>' +
      _btnFull('Түсіндім');
    return;
  }
  if (info.is_premium) {
    card.innerHTML = _closeX() + _CAND +
      '<h2 style="font-family:Georgia,serif;font-size:20px;text-align:center;color:var(--ink);margin:8px 0 8px">Сен — Жан доссың!</h2>' +
      '<p style="font-size:13px;text-align:center;opacity:.7;margin:0 0 20px">Барлық мүмкіндік ашық. Рақмет!</p>' +
      _btnFull('Жабу');
    return;
  }
  if (info.pending_order) { _renderPending(card); return; }
  const tiers = (info.tiers && info.tiers.length) ? info.tiers : [{ months: 1, amount: info.price, per: info.price, label: '1 ай' }];
  if (!tiers.some(t => t.months === _selMonths)) _selMonths = tiers[0].months;
  _renderPay(card, info, tiers);
}

function _renderPay(card, info, tiers) {
  const sel = tiers.find(t => t.months === _selMonths) || tiers[0];
  const stepNum = (n) => '<div style="width:24px;height:24px;border-radius:50%;background:var(--ac);color:#fff;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:center;flex:none">' + n + '</div>';
  const tierCards = tiers.map(t => {
    const active = t.months === _selMonths;
    const badge = t.badge ? '<div style="position:absolute;top:-8px;left:50%;transform:translateX(-50%);background:#E9A949;color:#2a1d0a;font-size:8.5px;font-weight:700;padding:2px 7px;border-radius:99px;white-space:nowrap">' + esc(t.badge) + '</div>' : '';
    const per = (t.per && t.months > 1) ? '<div style="font-size:9.5px;opacity:.55;margin-top:1px">' + t.per + '₸/ай</div>' : '<div style="height:12px"></div>';
    return '<button data-tier="' + t.months + '" style="position:relative;border:1.5px solid ' + (active ? '#E9A949' : '#e7ddc9') + ';background:' + (active ? 'rgba(233,169,73,.1)' : 'var(--card)') + ';border-radius:12px;padding:11px 6px;cursor:pointer;text-align:center">' + badge +
      '<div style="font-size:13px;font-weight:700;color:var(--ink)">' + esc(t.label) + '</div>' +
      '<div style="font-family:Georgia,serif;font-size:15px;color:#8B5E34;font-weight:700;margin-top:2px">' + t.amount + '₸</div>' + per + '</button>';
  }).join('');
  card.innerHTML = _closeX() + _CAND +
    '<h2 style="font-family:Georgia,serif;font-size:20px;text-align:center;color:var(--ink);margin:2px 0 14px">Жан дос бол</h2>' +
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:18px">' + tierCards + '</div>' +
    '<div style="display:flex;gap:10px;align-items:flex-start;margin-bottom:11px">' + stepNum(1) +
      '<div style="font-size:13px;padding-top:1px"><b id="jcAmt">Kaspi арқылы ' + sel.amount + '₸ аудар</b><div style="font-size:11px;opacity:.6">Комментке атыңды жаз</div></div></div>' +
    '<a href="' + esc(info.kaspi_url) + '" target="_blank" rel="noopener" style="display:flex;align-items:center;justify-content:center;width:100%;padding:13px;background:#F14635;color:#fff;border-radius:12px;font-weight:700;font-size:14px;text-decoration:none;margin-bottom:18px">Kaspi-ге өту</a>' +
    '<div style="display:flex;gap:10px;align-items:flex-start;margin-bottom:9px">' + stepNum(2) +
      '<div style="font-size:13px;padding-top:1px"><b>Чегіңді жүкте</b><div style="font-size:11px;opacity:.6">Скриншот не PDF</div></div></div>' +
    '<div id="jcDrop" style="border:2px dashed #C9A96E;border-radius:12px;padding:18px;text-align:center;color:var(--ac);font-size:13px;cursor:pointer;margin-bottom:14px">📎 Чек таңда</div>' +
    '<input type="file" id="jcFile" accept="image/*,.pdf" style="display:none">' +
    '<button id="jcSubmit" disabled style="width:100%;padding:13px;background:var(--ac);color:var(--card);border:none;border-radius:999px;font-weight:600;font-size:14px;cursor:pointer;opacity:.5">Жіберу</button>' +
    '<div style="font-size:11px;text-align:center;opacity:.55;margin-top:10px">Чегің тек тексеру үшін — ешкімге көрсетілмейді</div>';
  card.querySelectorAll('[data-tier]').forEach(b => b.onclick = () => { _selMonths = +b.dataset.tier; _renderPay(card, info, tiers); });
  const file = card.querySelector('#jcFile'), drop = card.querySelector('#jcDrop'), submit = card.querySelector('#jcSubmit');
  let chosen = null;
  drop.onclick = () => file.click();
  file.onchange = () => { const f = file.files[0]; if (f) { chosen = f; drop.textContent = '✓ ' + f.name; drop.style.borderStyle = 'solid'; drop.style.color = '#4A5D3A'; drop.style.borderColor = '#4A5D3A'; submit.disabled = false; submit.style.opacity = '1'; } };
  submit.onclick = () => { if (chosen) _doCheckoutSubmit(card, chosen, _selMonths, submit); };
}

async function _doCheckoutSubmit(card, file, months, btn) {
  btn.disabled = true; btn.textContent = 'Жіберілуде…';
  const fd = new FormData(); fd.append('file', file); fd.append('months', String(months));
  try {
    const r = await fetch('/api/premium/order', { method: 'POST', credentials: 'include', body: fd });
    const j = await r.json();
    if (j && j.already_premium) { _renderCheckout(card, { enabled: true, is_premium: true }); return; }
    if (!r.ok || !j.ok) { toast((j && j.detail) || 'Қате'); btn.disabled = false; btn.textContent = 'Жіберу'; return; }
    _renderPending(card);
  } catch (e) { toast('Желі қатесі'); btn.disabled = false; btn.textContent = 'Жіберу'; }
}

function _renderPending(card) {
  card.innerHTML = _closeX() +
    '<div style="font-size:46px;text-align:center;margin:8px 0 4px">🕯</div>' +
    '<div style="display:block;width:fit-content;margin:0 auto 12px;background:rgba(233,169,73,.16);color:var(--ac);font-size:11px;font-weight:700;padding:5px 12px;border-radius:99px">⏳ Тексерілуде</div>' +
    '<h2 style="font-family:Georgia,serif;font-size:19px;text-align:center;color:var(--ink);margin:0 0 8px">Тапсырысың қабылданды!</h2>' +
    '<p style="font-size:13px;text-align:center;opacity:.7;line-height:1.5;margin:0 0 20px">Чегіңді тексеріп, Жан досты бірден қосамыз. Әдетте бірнеше сағатта.</p>' +
    _btnFull('Жабу');
}

export function closeCheckoutModal() {
  const modal = document.getElementById('jandos-checkout-modal');
  if (!modal) return;
  modal.classList.remove('open');
  modal.style.display = 'none';
  document.body.style.overflow = '';
}

export function jandosBack() {
  show('profile');
}
